var _style, _path, _path2, _path3, _path4, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    id: "logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    #logo:hover #star,\n    #logo[data-spin] #star {\n      animation: star_rotate 2s ease forwards infinite;\n    }\n    @keyframes star_rotate {\n      from {\n        transform: rotate(0);\n      }\n      to {\n        transform: rotate(360deg);\n      }\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "book_filling",
    fill: "#ffe0b2",
    d: "       M 10 50       L 50 70       L 90 50       L 90 35       L 50 55       L 10 35       A 10 10 0 0 0 10 50       M 10 65       L 50 85       L 90 65       L 90 50       L 50 70       L 10 50       A 10 10 0 0 0 10 65     "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "book_top_cover",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "       M 50 15       L 90 35       L 50 55       L 10 35       z     "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "book_outlines",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "       M 10 50       L 30 60       M 47.5 68.75       L 50 70       L 90 50       M 10 65       L 50 85       L 90 65       M 10 35       A 10 10 0 0 0 10 50       A 10 10 0 0 0 10 65     "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "bookmark",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "       M 35 55       L 35 71.25       L 38.75 69.25       L 42.5 74.75       L 42.5 58.75       z     "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,34) rotate(26.565) skewX(-26.565) scale(0.10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star",
    fill: "#ffe0b2",
    stroke: "#ffe0b2",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "         M 0.000 -100.000         L 29.389 -40.451         L 95.106 -30.902         L 47.553 15.451         L 58.779 80.902         L 0.000 50.000         L -58.779 80.902         L -47.553 15.451         L -95.106 -30.902         L -29.389 -40.451         z       "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.af21f6ef.svg";
export { ForwardRef as ReactComponent };